@if (hasMenu) {
  <icon-triggered-context-menu [customAriaLabel]="widgetMenuLabel()" [menuItemsFactory]="menuItemsFactory" />
}
